import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import is from 'is_js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppContext from 'context/Context';
import FalconRoutes from 'routes';
import { CloseButton } from 'components/common/Toast';
import AppInsightsErrorBoundary from 'components/common/AppInsightsErrorBoundary';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    HTMLClassList.add('double-top-nav-layout');
  }, []);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
        staleTime: 'infinity',
      },
    },
  });

  return (
    <AppInsightsErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router basename={process.env.PUBLIC_URL}>
          <FalconRoutes />
          <ToastContainer
            closeButton={CloseButton}
            icon={false}
            position={toast.POSITION.BOTTOM_LEFT}
          />
        </Router>
        <ReactQueryDevtools initialIsOpen />
      </QueryClientProvider>
    </AppInsightsErrorBoundary>
  );
};

export default App;
